import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

/** InPost mark shown inside the yellow badge (Figma 436-3687). */
function InPostSunMark() {
  return (
    <svg
      width={14}
      height={20.844}
      viewBox="0 0 20 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.43748 14.6562C7.43748 14.6562 5.77288 15.3125 3.71874 15.3125C1.6646 15.3125 0 14.6562 0 14.6562C0 14.6562 1.6646 14 3.71874 14C5.77288 14 7.43748 14.6562 7.43748 14.6562Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.25 5.68749C12.25 5.68749 10.8535 4.7519 9.76538 3.18259C8.67925 1.61129 8.3125 0 8.3125 0C8.3125 0 9.70896 0.933587 10.7971 2.50489C11.8853 4.0762 12.25 5.68749 12.25 5.68749Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.31249 9.62499C8.31249 9.62499 6.65467 9.4482 4.9631 8.60226C3.27153 7.75632 2.1875 6.5625 2.1875 6.5625C2.1875 6.5625 3.84532 6.73929 5.53688 7.58523C7.22845 8.43117 8.31249 9.62499 8.31249 9.62499Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.25 23.625C12.25 23.625 10.8535 24.5606 9.76538 26.1299C8.67925 27.6992 8.3125 29.3125 8.3125 29.3125C8.3125 29.3125 9.70896 28.3789 10.7971 26.8076C11.8853 25.2383 12.25 23.625 12.25 23.625Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.31249 19.6875C8.31249 19.6875 6.65467 19.8895 4.9631 20.8563C3.27153 21.8231 2.1875 23.1875 2.1875 23.1875C2.1875 23.1875 3.84532 22.9854 5.53688 22.0187C7.22845 21.0519 8.31249 19.6875 8.31249 19.6875Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5539 17.8318C13.8556 21.0844 15.9479 23.4163 19.6854 23.9695C19.2591 24.026 18.8266 24.0603 18.3837 24.0624C13.0878 24.0846 8.77286 19.9901 8.75009 14.9164C8.72733 9.84266 13.0009 5.7098 18.2968 5.68759C18.7686 5.68557 19.2322 5.71787 19.6875 5.77844C15.4056 6.29934 12.5497 9.54183 11.9847 13.6686C11.8047 16.1843 14.8076 17.0343 14.8076 17.0343C14.8076 17.0343 13.5783 17.8176 12.5539 17.8338V17.8318Z"
        fill="black"
      />
    </svg>
  );
}

/**
 * Storefront free-shipping countdown card preview (Figma 436-3686 / 436-3740),
 * mirroring the theme block: yellow sun badge, progress bar on top (black while
 * progressing, yellow once unlocked) and the status line below.
 */
export function FreeShippingPreview({ complete }: { complete: boolean }) {
  const { t } = useTranslation('widgets');

  const message = complete
    ? t('freeShipping.previewMessage.unlocked')
    : t('freeShipping.previewMessage.away', {
        amount: t('freeShipping.previewMessage.sampleAmount'),
      });

  return (
    <div className="flex h-[81px] w-full items-center justify-center rounded-[12px] bg-white p-3">
      <div
        className="flex w-full max-w-[418px] items-center gap-[15px]"
        style={{ fontFamily: "'Google Sans', system-ui, -apple-system, sans-serif" }}
      >
        <span className="flex size-8 shrink-0 items-center justify-center rounded-[12px] bg-[#ffcc05]">
          <InPostSunMark />
        </span>
        <div className="flex min-w-0 flex-1 flex-col gap-[9px]">
          <div className="h-1 w-full overflow-hidden rounded-[12px] bg-[#f5f5f5]">
            <div
              className={cn(
                'h-full rounded-[12px]',
                complete ? 'w-full bg-[#ffcc05]' : 'w-[22%] bg-black',
              )}
            />
          </div>
          <p className="text-[14px] leading-4 text-[#6e6e6e]">{message}</p>
        </div>
      </div>
    </div>
  );
}
